// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CommunityMap — full-bleed interactive section
   Uses client's exact tokens from master.css throughout
   ============================================================ */

.cmap {
  background: var(--c-ink);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

/* ── Header bar ─────────────────────────────────────────────── */
.cmap__header {
  background: var(--c-cream);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 4vw, 3.5rem);
  border-bottom: 1px solid var(--line);
  flex-wrap: wrap;
  gap: 1rem;
}

.cmap__header-left {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 2.5vw, 2rem);
  flex-wrap: wrap;
}

.cmap__header-title {
  font-size: clamp(1.4rem, 3vw, 2.2rem);
  color: var(--accent);
  margin: 0;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.cmap__header-rule {
  display: block;
  width: 1px;
  height: clamp(2rem, 4vw, 3rem);
  background: var(--line);
  flex-shrink: 0;
}

.cmap__header-sub {
  font-family: var(--font-body);
  font-size: clamp(0.82rem, 1.1vw, 0.95rem);
  color: var(--text-muted);
  line-height: 1.55;
  margin: 0;
}

.cmap__header-right {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 2vw, 2rem);
  margin-left: auto;
}

.cmap__header-count {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
}

.cmap__header-num {
  font-family: var(--font-display);
  font-size: clamp(1.8rem, 3.5vw, 2.8rem);
  color: var(--accent);
  line-height: 1;
  letter-spacing: 0.02em;
}

.cmap__header-count-label {
  font-family: var(--font-body);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--c-ink);
  line-height: 1.4;
}

/* Badge in header */
.cmap__header-right .wws__badge {
  width: clamp(56px, 6.5vw, 80px) !important;
  height: clamp(56px, 6.5vw, 80px) !important;
}

/* ── Filter bar ─────────────────────────────────────────────── */
.cmap__filters {
  background: #1a1a12;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0 clamp(1rem, 3vw, 2.5rem);
  overflow-x: auto;
  scrollbar-width: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.cmap__filters::-webkit-scrollbar {
  display: none;
}

.cmap__filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.55);
  padding: 0.9rem 1.1rem;
  white-space: nowrap;
  transition:
    color 0.3s var(--ease),
    border-color 0.3s var(--ease),
    background 0.3s var(--ease);
}

.cmap__filter-btn:first-child {
  border: 1px solid rgba(168, 102, 66, 0.6);
  color: var(--c-cream);
  margin-right: 0.5rem;
  padding: 0.55rem 1.1rem;
}

.cmap__filter-btn:first-child.cmap__filter-btn--active {
  background: var(--accent);
  border-color: var(--accent);
}

.cmap__filter-btn:not(:first-child):hover {
  color: var(--c-cream);
}

.cmap__filter-btn--active:not(:first-child) {
  color: var(--c-cream);
  border-bottom-color: var(--accent);
}

.cmap__filter-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* ── Map body ───────────────────────────────────────────────── */
.cmap__body {
  position: relative;
  height: clamp(480px, 75vh, 780px);
  /* flex: 1; */
}

/* MapLibre canvas fills parent */
.cmap__body .maplibregl-map {
  width: 100% !important;
  height: 100% !important;
}

/* Hide default MapLibre attribution (we credit in footer) */
.maplibregl-ctrl-attrib {
  display: none !important;
}

/* ── Custom controls ────────────────────────────────────────── */
.cmap__controls {
  position: absolute;
  left: clamp(0.75rem, 2vw, 1.5rem);
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 2px;
  z-index: 10;
}

.cmap__ctrl-btn {
  width: 34px;
  height: 34px;
  background: rgba(26, 22, 14, 0.82);
  border: 1px solid rgba(220, 204, 180, 0.2);
  color: var(--c-sand);
  font-size: 1rem;
  font-family: var(--font-body);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  transition:
    background 0.25s var(--ease),
    color 0.25s var(--ease);
  backdrop-filter: blur(6px);
}

.cmap__ctrl-btn:hover {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.cmap__ctrl-btn:nth-child(3) {
  font-size: 0.8rem;
}

/* ── Cluster bubbles ────────────────────────────────────────── */
.cmap__cluster {
  background: #e8d9b8;
  border: 2px solid var(--c-cream);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.45);
  transition:
    transform 0.25s var(--ease),
    background 0.25s var(--ease);
}

.cmap__cluster:hover {
  transform: scale(1.12);
  background: var(--c-cream);
}

.cmap__cluster-num {
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--c-ink);
  letter-spacing: 0.05em;
}

/* ── Individual pins ────────────────────────────────────────── */
.cmap__pin-wrap {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5));
  transition: filter 0.25s var(--ease);
}

.cmap__pin-wrap--selected {
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.7)) drop-shadow(0 0 6px rgba(255, 255, 255, 0.4));
}

/* ── Story side panel ───────────────────────────────────────── */
.cmap__panel {
  position: absolute;
  top: clamp(0.75rem, 2vw, 1.25rem);
  right: clamp(0.75rem, 2vw, 1.25rem);
  bottom: clamp(0.75rem, 2vw, 1.25rem);
  width: clamp(280px, 28vw, 360px);
  background: var(--c-cream);
  display: flex;
  flex-direction: column;
  z-index: 20;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  border-radius: var(--radius-sm);
}

/* Portrait photo area */
.cmap__panel-portrait {
  position: relative;
  height: clamp(160px, 24vh, 240px);
  background: var(--c-forest);
  flex-shrink: 0;
  overflow: hidden;
}

.cmap__panel-portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.cmap__panel-portrait-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, var(--c-forest) 0%, #1e2a1e 100%);
}

.cmap__panel-portrait-placeholder svg {
  width: 80px;
  height: 80px;
}

/* Close button */
.cmap__panel-close {
  position: absolute;
  top: 0.65rem;
  right: 0.65rem;
  width: 2rem;
  height: 2rem;
  background: rgba(27, 27, 27, 0.55);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  transition: background 0.2s var(--ease);
  z-index: 2;
}

.cmap__panel-close:hover {
  background: var(--accent);
}

/* Panel body */
.cmap__panel-body {
  flex: 1 1;
  overflow-y: auto;
  padding: clamp(1.1rem, 2.5vw, 1.6rem) clamp(1.1rem, 2.5vw, 1.6rem);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  position: relative;
}

/* Category label */
.cmap__panel-cat {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-family: var(--font-body);
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.cmap__panel-cat-icon {
  display: flex;
  align-items: center;
}
.cmap__panel-cat-label {
  line-height: 1;
}

/* Name */
.cmap__panel-name {
  font-size: clamp(1.6rem, 3.5vw, 2.2rem);
  color: var(--c-ink);
  margin: 0;
  line-height: 0.95;
}

/* Meta: city · retreat */
.cmap__panel-meta {
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.cmap__panel-meta-dot {
  color: var(--accent);
  font-size: 0.9rem;
}

/* Stars */
.cmap__stars {
  display: flex;
  gap: 2px;
  align-items: center;
}

.cmap__star {
  font-size: 0.85rem;
  color: rgba(27, 27, 27, 0.2);
}
.cmap__star--filled {
  color: var(--accent);
}

/* Thin divider */
.cmap__panel-divider {
  height: 1px;
  background: var(--line);
  margin: 0.2rem 0;
}

/* Quote */
.cmap__panel-quote {
  font-family: var(--font-serif);
  font-style: italic;
  font-size: clamp(0.9rem, 1.4vw, 1.05rem);
  color: var(--c-ink);
  line-height: 1.55;
  margin: 0;
  border: none;
  padding: 0;
}

/* View story CTA */
.cmap__panel-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--accent);
  text-decoration: none;
  padding-top: 0.4rem;
  border-top: 1px solid var(--line);
  margin-top: auto;
  transition: gap 0.3s var(--ease);
}

.cmap__panel-cta:hover {
  gap: 0.85rem;
  color: var(--accent-hover);
}
.cmap__panel-cta-icon {
  font-size: 0.65rem;
  transition: transform 0.3s var(--ease);
}
.cmap__panel-cta:hover .cmap__panel-cta-icon {
  transform: translateX(3px);
}

/* Botanical watermark */
.cmap__panel-botanical {
  position: absolute;
  bottom: 1rem;
  transform: rotateY(-180deg);
  right: 0;
  width: 8vw;
  height: auto;
  color: var(--c-forest);
  opacity: 0.5;
  pointer-events: none;
}

/* ── Cluster view legend ─────────────────────────────────────── */
.cmap__legend {
  position: absolute;
  left: clamp(0.75rem, 2vw, 1.5rem);
  bottom: clamp(0.75rem, 2vw, 1.5rem);
  background: rgba(26, 22, 14, 0.78);
  border: 1px solid rgba(220, 204, 180, 0.18);
  backdrop-filter: blur(8px);
  padding: 0.85rem 1.1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  max-width: 200px;
  z-index: 10;
  border-radius: var(--radius-sm);
}

.cmap__legend-icon {
  color: var(--c-sand);
  font-size: 1.1rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.cmap__legend-title {
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--c-sand);
  margin: 0 0 0.2rem;
}

.cmap__legend-sub {
  font-family: var(--font-body);
  font-size: 0.65rem;
  color: rgba(220, 204, 180, 0.55);
  line-height: 1.45;
  margin: 0;
}

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 991.98px) {
  .cmap__header-rule {
    display: none;
  }
  .cmap__header-right .wws__badge {
    display: none;
  }
  .cmap__body {
    height: clamp(400px, 60vh, 600px);
  }
  .cmap__panel {
    width: clamp(260px, 85vw, 320px);
  }
}

@media (max-width: 767.98px) {
  .cmap__header {
    flex-direction: column;
    align-items: flex-start;
  }
  .cmap__header-right {
    margin-left: 0;
  }
  .cmap__body {
    height: 68vw;
    min-height: 380px;
  }
  .cmap__panel {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 55%;
    border-radius: 0;
    flex-direction: row;
  }
  .cmap__panel-portrait {
    width: 36%;
    height: 100%;
  }
  .cmap__legend {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/CommunityMap.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4DAA4D;EAC5D,oCAAoC;EACpC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB;;;+BAG6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,wBAAwB;AAC1B;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B;;2BAEyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C;;gCAE8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,gGAAgG;AAClG;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,SAAO;EACP,gBAAgB;EAChB,kEAAkE;EAClE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,uCAAuC;EACvC,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,2CAA2C;EAC3C,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================================\n   CommunityMap — full-bleed interactive section\n   Uses client's exact tokens from master.css throughout\n   ============================================================ */\n\n.cmap {\n  background: var(--c-ink);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n/* ── Header bar ─────────────────────────────────────────────── */\n.cmap__header {\n  background: var(--c-cream);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 4vw, 3.5rem);\n  border-bottom: 1px solid var(--line);\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.cmap__header-left {\n  display: flex;\n  align-items: center;\n  gap: clamp(1rem, 2.5vw, 2rem);\n  flex-wrap: wrap;\n}\n\n.cmap__header-title {\n  font-size: clamp(1.4rem, 3vw, 2.2rem);\n  color: var(--accent);\n  margin: 0;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.cmap__header-rule {\n  display: block;\n  width: 1px;\n  height: clamp(2rem, 4vw, 3rem);\n  background: var(--line);\n  flex-shrink: 0;\n}\n\n.cmap__header-sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.82rem, 1.1vw, 0.95rem);\n  color: var(--text-muted);\n  line-height: 1.55;\n  margin: 0;\n}\n\n.cmap__header-right {\n  display: flex;\n  align-items: center;\n  gap: clamp(1rem, 2vw, 2rem);\n  margin-left: auto;\n}\n\n.cmap__header-count {\n  display: flex;\n  align-items: baseline;\n  gap: 0.6rem;\n}\n\n.cmap__header-num {\n  font-family: var(--font-display);\n  font-size: clamp(1.8rem, 3.5vw, 2.8rem);\n  color: var(--accent);\n  line-height: 1;\n  letter-spacing: 0.02em;\n}\n\n.cmap__header-count-label {\n  font-family: var(--font-body);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--c-ink);\n  line-height: 1.4;\n}\n\n/* Badge in header */\n.cmap__header-right .wws__badge {\n  width: clamp(56px, 6.5vw, 80px) !important;\n  height: clamp(56px, 6.5vw, 80px) !important;\n}\n\n/* ── Filter bar ─────────────────────────────────────────────── */\n.cmap__filters {\n  background: #1a1a12;\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 0 clamp(1rem, 3vw, 2.5rem);\n  overflow-x: auto;\n  scrollbar-width: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.cmap__filters::-webkit-scrollbar {\n  display: none;\n}\n\n.cmap__filter-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.55);\n  padding: 0.9rem 1.1rem;\n  white-space: nowrap;\n  transition:\n    color 0.3s var(--ease),\n    border-color 0.3s var(--ease),\n    background 0.3s var(--ease);\n}\n\n.cmap__filter-btn:first-child {\n  border: 1px solid rgba(168, 102, 66, 0.6);\n  color: var(--c-cream);\n  margin-right: 0.5rem;\n  padding: 0.55rem 1.1rem;\n}\n\n.cmap__filter-btn:first-child.cmap__filter-btn--active {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n\n.cmap__filter-btn:not(:first-child):hover {\n  color: var(--c-cream);\n}\n\n.cmap__filter-btn--active:not(:first-child) {\n  color: var(--c-cream);\n  border-bottom-color: var(--accent);\n}\n\n.cmap__filter-icon {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* ── Map body ───────────────────────────────────────────────── */\n.cmap__body {\n  position: relative;\n  height: clamp(480px, 75vh, 780px);\n  /* flex: 1; */\n}\n\n/* MapLibre canvas fills parent */\n.cmap__body .maplibregl-map {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Hide default MapLibre attribution (we credit in footer) */\n.maplibregl-ctrl-attrib {\n  display: none !important;\n}\n\n/* ── Custom controls ────────────────────────────────────────── */\n.cmap__controls {\n  position: absolute;\n  left: clamp(0.75rem, 2vw, 1.5rem);\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  z-index: 10;\n}\n\n.cmap__ctrl-btn {\n  width: 34px;\n  height: 34px;\n  background: rgba(26, 22, 14, 0.82);\n  border: 1px solid rgba(220, 204, 180, 0.2);\n  color: var(--c-sand);\n  font-size: 1rem;\n  font-family: var(--font-body);\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n  transition:\n    background 0.25s var(--ease),\n    color 0.25s var(--ease);\n  backdrop-filter: blur(6px);\n}\n\n.cmap__ctrl-btn:hover {\n  background: var(--accent);\n  color: #fff;\n  border-color: var(--accent);\n}\n\n.cmap__ctrl-btn:nth-child(3) {\n  font-size: 0.8rem;\n}\n\n/* ── Cluster bubbles ────────────────────────────────────────── */\n.cmap__cluster {\n  background: #e8d9b8;\n  border: 2px solid var(--c-cream);\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.45);\n  transition:\n    transform 0.25s var(--ease),\n    background 0.25s var(--ease);\n}\n\n.cmap__cluster:hover {\n  transform: scale(1.12);\n  background: var(--c-cream);\n}\n\n.cmap__cluster-num {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--c-ink);\n  letter-spacing: 0.05em;\n}\n\n/* ── Individual pins ────────────────────────────────────────── */\n.cmap__pin-wrap {\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5));\n  transition: filter 0.25s var(--ease);\n}\n\n.cmap__pin-wrap--selected {\n  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.7)) drop-shadow(0 0 6px rgba(255, 255, 255, 0.4));\n}\n\n/* ── Story side panel ───────────────────────────────────────── */\n.cmap__panel {\n  position: absolute;\n  top: clamp(0.75rem, 2vw, 1.25rem);\n  right: clamp(0.75rem, 2vw, 1.25rem);\n  bottom: clamp(0.75rem, 2vw, 1.25rem);\n  width: clamp(280px, 28vw, 360px);\n  background: var(--c-cream);\n  display: flex;\n  flex-direction: column;\n  z-index: 20;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  border-radius: var(--radius-sm);\n}\n\n/* Portrait photo area */\n.cmap__panel-portrait {\n  position: relative;\n  height: clamp(160px, 24vh, 240px);\n  background: var(--c-forest);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.cmap__panel-portrait img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n}\n\n.cmap__panel-portrait-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(160deg, var(--c-forest) 0%, #1e2a1e 100%);\n}\n\n.cmap__panel-portrait-placeholder svg {\n  width: 80px;\n  height: 80px;\n}\n\n/* Close button */\n.cmap__panel-close {\n  position: absolute;\n  top: 0.65rem;\n  right: 0.65rem;\n  width: 2rem;\n  height: 2rem;\n  background: rgba(27, 27, 27, 0.55);\n  border: none;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 0.8rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n  transition: background 0.2s var(--ease);\n  z-index: 2;\n}\n\n.cmap__panel-close:hover {\n  background: var(--accent);\n}\n\n/* Panel body */\n.cmap__panel-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: clamp(1.1rem, 2.5vw, 1.6rem) clamp(1.1rem, 2.5vw, 1.6rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  position: relative;\n}\n\n/* Category label */\n.cmap__panel-cat {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n}\n\n.cmap__panel-cat-icon {\n  display: flex;\n  align-items: center;\n}\n.cmap__panel-cat-label {\n  line-height: 1;\n}\n\n/* Name */\n.cmap__panel-name {\n  font-size: clamp(1.6rem, 3.5vw, 2.2rem);\n  color: var(--c-ink);\n  margin: 0;\n  line-height: 0.95;\n}\n\n/* Meta: city · retreat */\n.cmap__panel-meta {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cmap__panel-meta-dot {\n  color: var(--accent);\n  font-size: 0.9rem;\n}\n\n/* Stars */\n.cmap__stars {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n}\n\n.cmap__star {\n  font-size: 0.85rem;\n  color: rgba(27, 27, 27, 0.2);\n}\n.cmap__star--filled {\n  color: var(--accent);\n}\n\n/* Thin divider */\n.cmap__panel-divider {\n  height: 1px;\n  background: var(--line);\n  margin: 0.2rem 0;\n}\n\n/* Quote */\n.cmap__panel-quote {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-size: clamp(0.9rem, 1.4vw, 1.05rem);\n  color: var(--c-ink);\n  line-height: 1.55;\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n\n/* View story CTA */\n.cmap__panel-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--accent);\n  text-decoration: none;\n  padding-top: 0.4rem;\n  border-top: 1px solid var(--line);\n  margin-top: auto;\n  transition: gap 0.3s var(--ease);\n}\n\n.cmap__panel-cta:hover {\n  gap: 0.85rem;\n  color: var(--accent-hover);\n}\n.cmap__panel-cta-icon {\n  font-size: 0.65rem;\n  transition: transform 0.3s var(--ease);\n}\n.cmap__panel-cta:hover .cmap__panel-cta-icon {\n  transform: translateX(3px);\n}\n\n/* Botanical watermark */\n.cmap__panel-botanical {\n  position: absolute;\n  bottom: 1rem;\n  transform: rotateY(-180deg);\n  right: 0;\n  width: 8vw;\n  height: auto;\n  color: var(--c-forest);\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* ── Cluster view legend ─────────────────────────────────────── */\n.cmap__legend {\n  position: absolute;\n  left: clamp(0.75rem, 2vw, 1.5rem);\n  bottom: clamp(0.75rem, 2vw, 1.5rem);\n  background: rgba(26, 22, 14, 0.78);\n  border: 1px solid rgba(220, 204, 180, 0.18);\n  backdrop-filter: blur(8px);\n  padding: 0.85rem 1.1rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  max-width: 200px;\n  z-index: 10;\n  border-radius: var(--radius-sm);\n}\n\n.cmap__legend-icon {\n  color: var(--c-sand);\n  font-size: 1.1rem;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.cmap__legend-title {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--c-sand);\n  margin: 0 0 0.2rem;\n}\n\n.cmap__legend-sub {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  color: rgba(220, 204, 180, 0.55);\n  line-height: 1.45;\n  margin: 0;\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n@media (max-width: 991.98px) {\n  .cmap__header-rule {\n    display: none;\n  }\n  .cmap__header-right .wws__badge {\n    display: none;\n  }\n  .cmap__body {\n    height: clamp(400px, 60vh, 600px);\n  }\n  .cmap__panel {\n    width: clamp(260px, 85vw, 320px);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .cmap__header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .cmap__header-right {\n    margin-left: 0;\n  }\n  .cmap__body {\n    height: 68vw;\n    min-height: 380px;\n  }\n  .cmap__panel {\n    top: auto;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 55%;\n    border-radius: 0;\n    flex-direction: row;\n  }\n  .cmap__panel-portrait {\n    width: 36%;\n    height: 100%;\n  }\n  .cmap__legend {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
